export default {
  'ROBOT:EXCEPTION': 'Ồ ! Có trục trặc từ phía chúng tôi rồi. Đừng lo mà, không phải tại bạn đâu. Xin lỗi về điều đó nhé',
  'ROBOT:NOANSWER': 'Xin lỗi, tôi chưa hiểu lắm, bạn có thể hỏi bằng cách khác được mà',
  'ROBOT:SUGGEST': 'Tôi nghĩ là bạn muốn nói gì đó phải không',
  'LOGIN:SUCCESS': 'Tuyệt ! Giờ thì bạn đã đăng nhập được hệ thống rồi đó!',
  'KNOWLEDGE:GOOD': 'Tôi có thể giúp gì thêm cho bạn?',
  'KNOWLEDGE:BAD': 'Có vẻ như phản hồi của tôi không hữu ích cho bạn thì phải. Hay là bạn thử đặt lại câu hỏi hay hỏi gì khác nhé?',
  'SHIPPING:ADDRESS': 'Địa chỉ giao hàng',
  'ROBOT:RECOMMEND': 'Bạn vẫn muốn biết các mục sau chứ:',
  'ROBOT:RECOMMEND:RELATED': 'Tôi thấy các đề xuất sau đây có lẽ sẽ liên quan tới câu hỏi của bạn:',
  'TRACKING:DETAIL': 'Thông tin tra cứu',
  'ORDER:STATUS': 'Trạng thái đơn hàng',
  'CANCEL:ITEM': 'Hủy sản phẩm',
  'BUTTON:MORE': 'Xem thêm',
  'SHOW:ALLORDERS': 'Hiện ra hết tất cả các đơn hàng của tôi',
  'ROBOT:WELCOME': '...hoặc trả lời các câu hỏi của bạn về Lazada.',
  'ROBOT:LIVEAGENT': 'Tôi muốn gặp tư vấn viên',
  'PAGE:404': 'Xin lỗi, trang của bạn hiện không tồn tại',
  'WORD:ITEM': 'Sản phẩm',
  'FEEDBACK:QUESTION': 'Bạn thấy cái này có ích chứ ?',
  'FEEDBACK:THANKS': 'Cảm ơn bạn!',
  'LIVE:AGENT': 'Gặp tư vấn viên',
  openOrder: n => `Được rồi, bạn đang có ${n} đơn hàng chưa được giao`,
  indexOrder: (o, n) => `Đơn hàng ${o} của ${n}`,
  packageDetail: (o, n) => `Các thông tin cho đơn hàng ${o} với số kiện hàng ${n}`,
  orderDetail: (o, p, n) => `Đơn hàng số ${o} đã đặt ${p} có ${n} sản phẩm`,
  packageOrder: (p, n) => `Kiện hàng ${p} của ${n}`,
  tracking: (p, n) => `Đây là thông tin tra cứu cho <span class="bold"> kiện hàng ${p}</span> của đơn hàng số <span class="bold">${n}</span>`,
};




// WEBPACK FOOTER //
// ./src/bu/pc/locales/vi-vn.js